import { createElement, Fragment, type ReactNode } from 'react';
import type { LegalNode, LegalSlotName } from './types';

export type LegalSlots = Readonly<Partial<Record<LegalSlotName, ReactNode>>>;

interface LegalNodesProps {
  readonly nodes: readonly LegalNode[];
  /** What to render at each slot; a slot without an entry renders nothing. */
  readonly slots?: LegalSlots;
}

function renderNode(node: LegalNode, key: number, slots: LegalSlots): ReactNode {
  if (typeof node === 'string') return node;
  if ('slot' in node) return <Fragment key={key}>{slots[node.slot]}</Fragment>;
  const { tag, children, ...attributes } = node;
  return createElement(
    tag,
    { key, ...attributes },
    children === undefined ? undefined : children.map((child, index) => renderNode(child, index, slots)),
  );
}

/** Renders verbatim legal copy (src/content/legal) as plain elements, in order. */
export function LegalNodes({ nodes, slots = {} }: LegalNodesProps) {
  return <>{nodes.map((node, index) => renderNode(node, index, slots))}</>;
}
